import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const Module1Page = lazy(() => import('../pages/module1/page'));
const Module2Page = lazy(() => import('../pages/module2/page'));
const Module3Page = lazy(() => import('../pages/module3/page'));
const Module4Page = lazy(() => import('../pages/module4/page'));
const Module5Page = lazy(() => import('../pages/module5/page'));
const Module6Page = lazy(() => import('../pages/module6/page'));
const Module7Page = lazy(() => import('../pages/module7/page'));
const Module8Page = lazy(() => import('../pages/module8/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/module1',
    element: <Module1Page />,
  },
  {
    path: '/module2',
    element: <Module2Page />,
  },
  {
    path: '/module3',
    element: <Module3Page />,
  },
  {
    path: '/module4',
    element: <Module4Page />,
  },
  {
    path: '/module5',
    element: <Module5Page />,
  },
  {
    path: '/module6',
    element: <Module6Page />,
  },
  {
    path: '/module7',
    element: <Module7Page />,
  },
  {
    path: '/module8',
    element: <Module8Page />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
